import { View } from "ui/atoms/view";
import { CheckIcon, ChevronRightIcon, Icon } from "ui/gluestack/icon";
import { Pressable, Text } from "react-native";
import { ResidentModel } from "../../../services/api/types/residents/models/ResidentModel";
import { formatAttendingResidents } from "ui/utils/nameUtil";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

export interface Props {
  resident?: ResidentModel;
  residents?: ResidentModel[];
  onRowPress: () => void;
  backgroundColourClass: string;
  isCompleted: boolean | undefined;
  handleMarkAsDone: () => void;
  renderContent: () => React.ReactNode;
  allResidents?: boolean;
  preparationNeeded?: boolean;
  permission?: PermissionsEnums;
}

export function TaskItem({
  resident,
  residents,
  onRowPress,
  backgroundColourClass,
  isCompleted,
  handleMarkAsDone,
  renderContent,
  allResidents,
  preparationNeeded,
  permission,
}: Props) {
  let attendingResidents: ResidentModel[] = [];

  if (residents && residents.length > 0) {
    attendingResidents = residents;
  } else if (resident) {
    attendingResidents = [resident];
  }

  return (
    <Pressable
      className={`flex ${backgroundColourClass} rounded-md px-4 py-2 mb-2`}
      onPress={onRowPress}
    >
      <View className="flex-row gap-3 items-center w-full">
        <PermissionCheck permission={permission}>
          <Pressable
            className={`rounded-full w-5 h-5 border-2 items-center justify-center ${isCompleted ? "opacity-50 bg-background-500" : "bg-white border-background-300"}`}
            onPress={handleMarkAsDone}
          >
            {isCompleted && (
              <Icon as={CheckIcon} className="w-3 h-3 stroke-white stroke-4" />
            )}
          </Pressable>
        </PermissionCheck>
        <View className="flex-1">
          <Text className="text-base font-medium">
            {formatAttendingResidents(attendingResidents!, allResidents)}
          </Text>
          {renderContent()}
          {preparationNeeded && (
            <Text className="mt-2 xl:hidden">Preparation needed</Text>
          )}
        </View>

        {preparationNeeded && (
          <View className="hidden xl:flex xl:flex-col xl:justify-center xl:items-end xl:ml-4">
            <Text className="leading-tight text-center">
              Preparation
              <br />
              needed
            </Text>
          </View>
        )}

        <Icon
          as={ChevronRightIcon}
          size="lg"
          className="text-primary-600 ml-2 self-center"
        />
      </View>
    </Pressable>
  );
}
